var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.payload ? _c('div', [_c('NFTLogoPayloadView', {
    attrs: {
      "payload": _vm.payloadBase
    }
  })], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }